import React from 'react';
import styled, { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;

const Reply = ({
  theme
}) => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-label": "reply"
}, /*#__PURE__*/React.createElement("path", {
  fill: theme.primary.main,
  d: "M37.62 55.13L48.34 44.4H8V6.05h4V40.4h36.34L36.91 28.96l2.83-2.82L56 42.4 40.44 57.95l-2.82-2.82z",
  "data-name": "Laag 1"
}));

Reply.propTypes = {
  theme: PropTypes.shape({
    primary: PropTypes.shape({
      main: PropTypes.string
    })
  }).isRequired
};
export default withTheme(Reply);